// EncabezadoOperativo — título de una pantalla financiera + selector de
// cooperativa cuando la vista activa no es de una cooperativa concreta.
// Renderiza sus hijos solo cuando ya hay una cooperativa sobre la cual operar.

import React from 'react';
import { Alert, Box, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

export default function EncabezadoOperativo({ titulo, subtitulo, operativa, acciones, children }) {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2, mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {titulo}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {subtitulo}
            {!operativa.seleccionable && operativa.cooperativa?.nombre ? ` — ${operativa.cooperativa.nombre}` : ''}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
          {operativa.seleccionable && (
            <FormControl size="small" sx={{ minWidth: 260 }}>
              <InputLabel>Cooperativa</InputLabel>
              <Select label="Cooperativa" value={operativa.cooperativaId || ''} onChange={(e) => operativa.elegir(e.target.value)}>
                {operativa.opciones.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {operativa.cooperativaId && acciones}
        </Box>
      </Box>

      {operativa.error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {operativa.error}
        </Alert>
      )}

      {operativa.cargando ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      ) : !operativa.cooperativaId ? (
        <Alert severity="info">
          {operativa.opciones.length === 0
            ? 'Aún no hay cooperativas activas. Regístralas o impórtalas desde «Administración de la Red».'
            : 'Selecciona la cooperativa sobre la que quieres trabajar.'}
        </Alert>
      ) : (
        children
      )}
    </Box>
  );
}
